<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <template #default>
        <div class="grid sm:flex items-center gap-2">
          <span class="flex-1 flex items-center gap-2">
            <date-selector v-model="startDate" :readonly="getReadonly" :max-date="maxDate" placeholder="선택" @change="onChangeData" class="flex-1" />
            <span>~</span>
          </span>
          <date-selector v-model="endDate" :readonly="getReadonly" :max-date="maxDate" placeholder="선택" @change="onChangeData" class="flex-1" />
        </div>
      </template>
      <template #right>
        <div v-if="getReadonly" style="width: 20px;"></div>
      </template>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div class="flex-1 flex flex-wrap items-center gap-2">
        <date-selector v-model="startDate" :readonly="getReadonly" :max-date="maxDate" placeholder="선택" @change="onChangeData" class="w-full xl:w-128px" />
        <span>~</span>
        <date-selector v-model="endDate" :readonly="getReadonly" :max-date="maxDate" placeholder="선택" @change="onChangeData" class="flex-1 xl:w-128px" />
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import DateSelector from "@/components/selector/DateSelector";
import moment from "moment";
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchStartEnd",
  components: {
    SearchFilterItem,
    SearchLabelBody,
    DateSelector,
    SearchNavItemSelect,
  },
  props: {
    label: {
      default: "대상기간",
      type: String,
    },
    value: [String, Object],
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          sd: "",
          ed: "",
        };
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      const { startDate, endDate } = value;
      this.startDate = startDate || '';
      this.endDate = endDate || '';
    },
  },
  data() {
    return {
      startDate: "",
      endDate: "",
    };
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    initData() {
      const defaultValue = this.options && this.options["default"] ? this.options["default"] : { sd: "", ed: "" };
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const sd = query[_query_keys[0]];
      const ed = query[_query_keys[1]];
      const data = {
        startDate: sd || defaultValue.sd || '',
        endDate: ed || defaultValue.ed || '',
      };
      return data;
    },
    gridTemplateColumns() {
      return this.options && this.options.gridTemplateColumns ? this.options.gridTemplateColumns : 'auto auto';
    },
    optionReadonly() {
      return this.options && this.options.readonly ? this.options.readonly : false;
    },
    // options.maxDate: 두 달력 모두 이 날짜 이후는 선택 불가 (예: 오늘까지만)
    maxDate() {
      return this.options && this.options.maxDate ? this.options.maxDate : "";
    },
    getReadonly() {
      return this.readonly || this.optionReadonly;
    }
  },
  created() {
    this.startDate = this.initData.startDate;
    this.endDate = this.initData.endDate;
    this.$emit("input", { startDate: this.startDate, endDate: this.endDate });

    if (this.$eventbus) {
      this.$eventbus.$on("searchItem-setInitData", () => {
        this.startDate = this.initData.startDate;
        this.endDate = this.initData.endDate;
        this.$emit("input", { startDate: this.startDate, endDate: this.endDate });
      });
    }
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    onChangeData() {
      if (!!this.startDate.trim() && !!this.endDate.trim()) {
        const sd = moment(this.startDate);
        const ed = moment(this.endDate);
        const diff = sd.diff(ed, "days");

        if (0 < diff) {
          this.$nextTick(() => {
            this.$set(this, "endDate", "");
          });
          window.dispatchEvent(new CustomEvent("customAlert", {
            detail: {
              title: "날짜 오류",
              message: "종료일이 시작일보다 이전입니다.\n올바른 날짜를 선택해주세요.",
              useConfirm: false,
              confirmBtn: "확인",
            },
          }));
          return;
        }
      }

      this.$emit("input", { startDate: this.startDate, endDate: this.endDate });
      this.$emit("change", { startDate: this.startDate, endDate: this.endDate });
      this.$emit("onSearch");

      const yearKey = this.options && this.options.autoFillYearKey;
      if (yearKey && this.options.nav && this.startDate) {
        const year = parseInt(this.startDate.substring(0, 4));
        if (!isNaN(year)) {
          this.$set(this.options.nav, yearKey, year);
        }
      }
    },
    onClickFilterRemove () {
      this.startDate = "";
      this.endDate = "";
      this.onChangeData();
    }
  },
};
</script>
